import { Avatar, Grid, IconButton, Typography } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import { formatPhoneNumber } from '../../../utilities/formatters';
import EmailIcon from '@mui/icons-material/Email';
import UserRoleSelector from '../../../components/user/UserRoleSelector';
import { PermissionsEnum, ProcureUser } from 'vendor-marketplace-shared-library';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';

type UserDetailsHeaderProps = {
  user: ProcureUser;
};
export default function UserDetailsHeader(props: UserDetailsHeaderProps) {
  const { validateUserPermissions } = useAuth();
  const navigate = useNavigate();

  return (
    <Grid item container rowGap={2}>
      <Grid item container columnGap={2}>
        {/*Back Button*/}
        <Grid item>
          <IconButton onClick={() => navigate('/users')}>
            <ArrowBackIcon />
          </IconButton>
        </Grid>
        {/*Name and role*/}
        <Grid item>
          <Grid item container direction={'row'} sx={styles.nameContainer} xs={12}>
            <Grid item>
              <Avatar />
            </Grid>
            <Grid item container direction={'column'}>
              <Grid item>
                <Typography variant={'h6'}>{props.user.fullName}</Typography>
              </Grid>
              <Grid item>
                <Typography variant={'caption'} color={'secondary.main'}>
                  {props.user.userRole?.name ?? 'No role'}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/*Contact info*/}
      <Grid item container direction={'row'} spacing={1} xs={12}>
        {/*Phone*/}
        <Grid item>
          <Grid container spacing={1}>
            <Grid item>
              <PhoneIcon />
            </Grid>
            <Grid item>
              <Typography>
                {formatPhoneNumber(props.user?.phoneContactMethod?.value || '') ??
                  'No phone number set'}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Typography>|</Typography>
        </Grid>
        {/*Email*/}
        <Grid item>
          <Grid container spacing={1}>
            <Grid item>
              <EmailIcon />
            </Grid>
            <Grid item>
              <Typography>{props.user.emailContactMethod?.value ?? 'No email set'}</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {/*Role Change*/}
      {validateUserPermissions([PermissionsEnum.USER_ROLE_UPDATE]) && (
        <Grid item xs={12}>
          <UserRoleSelector user={props.user} />
        </Grid>
      )}
    </Grid>
  );
}

const styles = {
  nameContainer: {
    flexWrap: 'nowrap',
    columnGap: 1,
  },
};
